"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.separator = exports.pageButton = exports.nextButton = exports.button = exports.root = void 0;

var _emotion = require("emotion");

var _consts = require("./consts");

var root =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:row;height:", _consts.PAGINATION_HEIGHT, "px;align-items:center;");
exports.root = root;
var button =
/*#__PURE__*/
(0, _emotion.css)("padding:0px 24px;height:", _consts.PAGINATION_HEIGHT, "px;width:auto;min-width:auto;");
exports.button = button;
var nextButton =
/*#__PURE__*/
(0, _emotion.css)("margin-left:8px;");
exports.nextButton = nextButton;

var pageButton = function pageButton() {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("padding:0px 7px;min-width:30px;height:", _consts.PAGINATION_HEIGHT, "px;border-radius:5px;margin-left:8px;")
  );
};

exports.pageButton = pageButton;

var separator = function separator(theme, isDarkTheme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("color:", isDarkTheme ? theme.color.white : theme.color.black3, ";margin-left:8px;")
  );
};

exports.separator = separator;